<template>
  <div class="contenedor_buscador flex justify-center">
    <FormularioNeumaticos v-if="paraNeumaticosYHome" />
    <ConsultBatteryMeasure v-if="paraBaterias" @callContact="callContact" />
    <FormularioAceite v-if="paraAceites" />

    <FormularioRevisionTecnica v-if="paraRevisionTecnica" />

    <FormularioGenerico
      :mostrar_busqueda_auto="false"
      v-if="   paraAfinamiento
            || paraAmortiguadores
            || paraBalanceo
            || paraGeometria
            || paraKilometraje
            || paraHigienizacion
            || paraFluidos
            || paraTrendelantero
            || paraFrenos
            || paraAlineacion
            || paraElectrico"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import FormularioNeumaticos from "~/components/Formularios/FormularioNeumaticos";
import FormularioAceite from "~/components/Formularios/FormularioAceite";
import FormularioGenerico from "~/components/Formularios/FormularioGenerico";
import FormularioRevisionTecnica from "~/components/Formularios/FormularioRevisionTecnica.vue";
import ConsultBatteryMeasure from "~/components/Home/Battery/ConsultBatteryMeasure";

import { NEGOCIOS } from "~/constants/negocios";

const modo_sistema = useState('modo_sistema');
const emit = defineEmits(["callContact"]);

const paraNeumaticosYHome = computed(() => (modo_sistema.value === NEGOCIOS.NEUMATICOS || modo_sistema.value === NEGOCIOS.HOME));
const paraBaterias        = computed(() => modo_sistema.value === NEGOCIOS.BATERIAS)
const paraAceites         = computed(() => modo_sistema.value === NEGOCIOS.ACEITES)
const paraFrenos          = computed(() => modo_sistema.value === NEGOCIOS.FRENOS)
const paraAfinamiento     = computed(() => modo_sistema.value === NEGOCIOS.AFINAMIENTO)
const paraAmortiguadores  = computed(() => modo_sistema.value === NEGOCIOS.AMORTIGUADORES)
const paraBalanceo        = computed(() => modo_sistema.value === NEGOCIOS.BALANCEO)
const paraGeometria       = computed(() => modo_sistema.value === NEGOCIOS.GEOMETRIA)
const paraKilometraje     = computed(() => modo_sistema.value === NEGOCIOS.KILOMETRAJE)
const paraHigienizacion   = computed(() => modo_sistema.value === NEGOCIOS.HIGIENIZACION)
const paraFluidos         = computed(() => modo_sistema.value === NEGOCIOS.FLUIDOS)
const paraTrendelantero   = computed(() => modo_sistema.value === NEGOCIOS.TRENDELANTERO)
const paraAlineacion      = computed(() => modo_sistema.value === NEGOCIOS.ALINEACION)
const paraElectrico       = computed(() => modo_sistema.value === NEGOCIOS.ELECTRICO)
const paraRevisionTecnica = computed(() => modo_sistema.value === NEGOCIOS.REVISIONTECNICA)

const callContact = () => {
  emit("callContact");
};
</script>